<template>
  <div class="main">
    <topImg class="honors" title="荣誉资质" desc="截止2024年末 公司已取得220项VR软件著作权及66项专利（包含在审查的16项）连续五年被评为中国虚拟现实50强企业、成功获批博士后科研工作站、北京“专精特新”企业、江西“专精特新”企业、种子独角兽企业，成功实施落地近千个项目案例。" img="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/historyHorner/banner_honer.png"></topImg>
    <div class="content">
      <div class="cert">
        <div class="title">XR软著专利和质量技术资质认证</div>
        <div class="imglist">
          <div class="list" v-for="item in imgArr" :key="item">
            <img :src="item.img"  alt="" srcset="">
            <div class="name">
              {{item.title}}
            </div>
            <div class="line"></div>
          </div>
        </div>
      </div>
      <div class="historyCert">
        <div class="title">行业荣誉和获奖证书</div>
        <div class="process">
          <div class="processLine">
            <div class="line"></div>
          </div>
          <div class="list">
            <div class="example" v-for="(item, index) in list" :key="item"  :class="index === 0 ? 'firstExample' : ''" >
              <div class="circle"><span></span></div>
              <div class="cantain">
                <div class="year">{{item.year}}</div>
                <div class="line"></div>
                <div class="desc">{{item.desc}}</div>
                <div class="certImgArr" >
                  <img :src="item.img" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { Pagination } from 'vant';
// import { newsList } from '@/services/api'

Vue.use(Pagination);

export default {
  data() {
    return {
      imgArr: [
        {
          img: 'https://growlib-glp-u-resources.oss-cn-beijing.aliyuncs.com/res/123/05fb5a6ef6b983ce7ceccbd6606b5af0.png',
          title: '国家高新技术企业证书'
        },
        {
          img: 'https://growlib-glp-u-resources.oss-cn-beijing.aliyuncs.com/res/123/7ed95af1e663192c1ceb90457ce533d0.png',
          title: 'XR软件著作权证书'
        },
        {
          img: 'https://growlib-glp-u-resources.oss-cn-beijing.aliyuncs.com/res/123/8be20236065c056a26fea877c6b3521f.png',
          title: 'ISO9001质量管理体系证书'
        }
      ],
      list: [
        {
          year: '2024年',
          desc: `《2024VRAR星球奖“最佳教育解决方案》、《2024专精特新百强企业》、《VRMTA会员单位》、《2024XR行业年度荣誉榜XR行业创新应用榜》《博士后科研工作站》、《江西种子独角兽企业》、《ITEC优胜奖》等`,
          img: require('@/assets/images/honors_2024.png')
        },
        {
          year: '2023年',
          desc: `《格如灵科技入选中国高校校办产业协会会员单位》、《格如灵科技荣获第八届“创客中国”江西省南昌市中小企业创新创业大赛优秀奖》、《中国VR50强企业》、
          《2023元宇宙最具投资价值关注榜-年度行业创新企业榜单》`,
          img: require('@/assets/images/honors_2023.png')
        },
        {
          year: '2022年',
          desc: `《2022中国VR50强企业》、《2022年度行业创新企业元宇宙最具投资价值荣誉证书》、《2022VR产业大会虚拟现实创新大赛三等奖》、《元宇宙技术创新奖》、
          《2022年元宇宙领域技术产业化创新应用优秀成果潜力奖》`,
          img: 'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_63e3674b859ce/760420948.png'
        },
        {
          year: '2021年',
          desc: `《中国VR50强企业》、《2021世界VR产业大会VR/AR创新奖》、《2021智能科学创新产品优秀项目》、《2021年教育部产学合作协同育人项目》、
            《IXRTVC 2021虚拟现实技术及应用创新大赛奖项》`,
          img: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/historyHorner/2021.png'
        },
        {
          year: '2020年',
          desc: `《2020世界VR产业大会-VR创新大赛一等奖》、《2020年度中国VR 50强企业》、《2020 ChinaBang Awards 智慧教育奖》、《2020虚拟与增强现实产业年会-金V奖》、
            《2020年度 XR行业最具影响力人物》、《2020年度优秀XR教育应用》、《第二届虚拟现实技术及应用创新大赛一等奖》、《中国虚拟现实科技创新与产业促进奖》`,
          img: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/historyHorner/2020.png'
        },
        {
          year: '2019年',
          desc: '《2019铅笔道真榜-影响时代教育科技公司TOP20》、《2019年度最佳应用奖》、《2019中国创新企业新苗榜-年度新锐企业》',
          img: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/historyHorner/2019.png'
        },
        {
          year: '2018年',
          desc: '《2018年互联网教育企业家年会-最具前沿教育科技奖》、《2018虚拟与增强现实产业生态高峰论坛-金V奖》、《2018年决胜网“新锐教育创业者”》',
          img: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/historyHorner/2018.png'
        },
        {
          year: '2017年',
          desc: '《2017北京国际VR/AR博览会“最佳VR教育市场服务品牌”》、《2017年度最佳商业应用奖》、《2017年“十三五”教科研课题实践基地》',
          img: 'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_63e369264222b/193427028.png'
        },
      ]
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>
<style lang="less" scoped>
/deep/.honors .cover{
  padding-top: 320px !important;
}
.main {
  background: #fff;
  .content{
    width: 100%;
    .cert{
      width: 1200px;
      padding-bottom: 97px;
      margin: 0 auto;
      .title{
        margin: 69px 0 54px 0;
        text-align: center;
        font-size: 28px;
        font-weight: bold;
      }
      .imglist{
        width: 100%;
        height: 360px;
        display: flex;
        justify-content: space-between;
        .list{
          width: 32%;
          height: 100%;
          background-color: #fff;
          border-radius: 19px;
          box-shadow: 0 0 14px #00000012;
          img{
            width: 100%;
            height: 263px;
          }
          .name{
            font-size: 22px;
            line-height: 30px;
            margin-top: 21px;
            padding: 0 29px;
            font-weight: bold;
          }
          .line{
            width: 27px;
            height: 4px;
            border-radius: 2px;
            background-color: #EF623D;
            margin: 10px 29px;
          }
        }
      }
    }
    .historyCert{
      width: 100%;
      height: auto;
      background: url('https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/backgroundImg/honner_zhengshu.png') no-repeat;
      background-size: 100% 100%;
      position: relative;
      .title{
        width: 100%;
        padding: 63px 0 30px 0;
        text-align: center;
        font-size: 28px;
        font-weight: bold;
      }
      .process{
        width: 1200px;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        justify-content: center;
        .processLine{
          width: 3px;
          height: 1910px;
          .line{
            width: 3px;
            height: 100%;
            background: url('./assets/bj_shijian_xian.png') no-repeat;
            background-size: 100% 100%;
            // background-color: #c9d5e2;
          }
        }
        .list{
          left: -14px;
          .example{
            display: flex;
            flex-direction: row;
            justify-content: start;
            .circle{
              width: 14px;
              min-height: 14px;
              margin:0 30px 320px 0;
              span{
                width: 14px;
                height: 14px;
                display: inline-block;
                border-radius: 14px;
                left: -8px;
                top: -10px;
                background-image: radial-gradient(#C9D5E3, #A2B8CC);
                position: relative;
              }
            }
            .cantain{
              display: flex;
              flex-direction: column;
              .year{
                font-size: 16px;
                font-weight: bold;
                margin-bottom: 10px;
              }
              .line{
                width: 27px;
                height: 4px;
                background-color: #EF623D;
                border-radius: 2px;
                margin-bottom: 12px;
              }
              .desc{
                font-size: 14px;
                line-height: 29px;
                margin-bottom: 8px;
              }
              .certImgArr{
                width: 100%;
                img{
                  height: 203px;
                }
              }
            }
          }
          .firstExample{
            margin-top: 61px;
          }
        }
      }
    }
  }
}
</style>
